var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKingStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4062 116.156C51.3906 119.961 49.4453 122.57 44.7656 123.922L44.125 122.531C46.2812 121.938 47.6875 121.094 48.5312 120.047L44.3281 120.359L44.0625 118.984L49.25 118.789C49.3984 118.398 49.4922 117.984 49.5391 117.547H44.7812V116.156H51.4062ZM45.9688 126.625C45.9688 124.875 47.8203 123.859 50.8281 123.859C53.7578 123.859 55.625 124.875 55.625 126.625C55.625 128.367 53.7578 129.359 50.8281 129.359C47.8203 129.359 45.9688 128.367 45.9688 126.625ZM47.7188 126.625C47.7188 127.516 48.8203 128.023 50.8281 128.016C52.7734 128.023 53.8984 127.516 53.8906 126.625C53.8984 125.719 52.7734 125.227 50.8281 125.234C48.8203 125.227 47.7188 125.719 47.7188 126.625ZM53.8281 123.656V115.281H55.5781V123.656H53.8281ZM65.2344 116.156C65.2188 119.961 63.2734 122.57 58.5938 123.922L57.9531 122.531C60.1094 121.938 61.5156 121.094 62.3594 120.047L58.1562 120.359L57.8906 118.984L63.0781 118.789C63.2266 118.398 63.3203 117.984 63.3672 117.547H58.6094V116.156H65.2344ZM59.7969 126.625C59.7969 124.875 61.6484 123.859 64.6562 123.859C67.5859 123.859 69.4531 124.875 69.4531 126.625C69.4531 128.367 67.5859 129.359 64.6562 129.359C61.6484 129.359 59.7969 128.367 59.7969 126.625ZM61.5469 126.625C61.5469 127.516 62.6484 128.023 64.6562 128.016C66.6016 128.023 67.7266 127.516 67.7188 126.625C67.7266 125.719 66.6016 125.227 64.6562 125.234C62.6484 125.227 61.5469 125.719 61.5469 126.625ZM67.6562 123.656V115.281H69.4062V123.656H67.6562ZM78.7656 117.203C78.7656 119.383 80.8984 121.578 83.8594 122.094L83.0781 123.547C80.7109 123.055 78.7734 121.617 77.8516 119.719C76.9219 121.602 74.9844 123.047 72.625 123.547L71.8594 122.094C74.7734 121.562 76.9141 119.375 76.9219 117.203V116.156H78.7656V117.203ZM71.4688 127.594V126.156H84.375V127.594H71.4688ZM92.5469 116.484V117.906H87.6406V120.422H92.2969V121.797H87.6406V124.703C89.8125 124.695 91.5156 124.602 93.4844 124.281L93.6406 125.688C91.4766 126.039 89.5703 126.109 87.0469 126.109H85.875V116.484H92.5469ZM94.625 129.391V115.266H96.3594V120.734H98.5312V122.188H96.3594V129.391H94.625Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.02 48.9995C119.02 75.5248 97.5258 97.0195 71.0005 97.0195C44.4751 97.0195 22.9805 75.5248 22.9805 48.9995C22.9805 22.4742 44.4751 0.979492 71.0005 0.979492C97.5258 0.979492 119.02 22.4742 119.02 48.9995Z",
    fill: "url(#paint0_linear_1275_5293)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49 48.9999C113.49 72.4668 94.4668 91.4905 70.9999 91.4905C47.533 91.4905 28.5093 72.4668 28.5093 48.9999C28.5093 25.533 47.533 6.50933 70.9999 6.50933C94.4668 6.50933 113.49 25.533 113.49 48.9999Z",
    stroke: "#FFC25D",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1275_5293)",
    filter: "url(#filter1_i_1275_5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5323 40.3789H48.9167C47.7538 40.3789 46.8281 41.3287 46.8281 42.4685V67.0215C46.8281 68.185 47.7775 69.1111 48.9167 69.1111H57.5323C58.6953 69.1111 59.6209 68.1612 59.6209 67.0215V42.4923C59.6209 41.3287 58.6953 40.3789 57.5323 40.3789Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0686 40.3789H76.0211C76.0211 40.3789 79.2727 36.5559 80.673 30.9994C81.3376 28.3399 80.6493 24.5406 79.249 23.0209C77.8961 21.5487 75.4515 22.166 74.9531 24.1132L73.6477 29.266C73.1493 31.1894 72.1287 32.9465 70.7046 34.3475L64.5337 40.3789L63.9166 40.9725C63.7505 41.115 63.6081 41.2812 63.4894 41.4475C63.2521 41.8274 63.0859 42.2785 63.0859 42.7535V66.8552C63.0859 68.185 64.154 69.2535 65.4831 69.2535H80.6493C85.3961 69.2535 89.5496 66.0479 90.7838 61.465L95.0322 45.5317C95.7205 42.9434 93.7743 40.3789 91.0686 40.3789Z",
    fill: "#FFC25D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5293",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5293",
    x: 46.8262,
    y: 22.2139,
    width: 48.3457,
    height: 48.0663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5293",
    x1: 37.6805,
    y1: 11.4328,
    x2: 107.75,
    y2: 79.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1275_5293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.3467,
    height: 47.04,
    fill: "white",
    transform: "translate(46.8262 22.2139)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingStar);
export default __webpack_public_path__ + "static/media/KingStar.14e2340492441e2bbb7ce6db1bb79491.svg";
export { ForwardRef as ReactComponent };